export default __webpack_public_path__ + "static/media/education_1.c6891ea3.png";